var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('td',_vm._g(_vm._b({style:(_vm.isArabic(_vm.row) ? 'direction: rtl;' : '')},'td',attrs,false),on),[_vm._v(" "+_vm._s(_vm.truncate(_vm.row, _vm.length))+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.row))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }